module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-list",
    attrs: {
      "id": "musiclist"
    }
  }, [_c('div', {
    ref: "bgImage",
    staticClass: "bg-image",
    style: (_vm.bgStyle)
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    ref: "layer",
    staticClass: "bg-layer"
  }), _vm._v(" "), _c('Scroll', {
    ref: "list",
    staticClass: "list",
    attrs: {
      "data": _vm.songs,
      "probe-type": _vm.probeType,
      "listen-scroll": _vm.listenScroll
    },
    on: {
      "scroll": _vm.scroll
    }
  }, [_c('div', {
    staticClass: "song-list-wrapper"
  }, [_c('song-list', {
    attrs: {
      "songs": _vm.songs
    },
    on: {
      "select": _vm.selectItem
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.songs.length),
      expression: "!songs.length"
    }],
    staticClass: "loading-container"
  }, [_c('loading')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42014d0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/music-list/music-list.vue
// module id = 570
// module chunks = 1